import styled from 'styled-components';

import BlueprintSrc from 'src/images/services/blueprint.png';

export const BlueprintBg = styled.div`
  background: url(${BlueprintSrc});
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media only screen and (min-width: 1024px) {
    justify-content: center;
    max-height: 40vh;
  }
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;

  max-width: 1300px;
  padding: 5rem 3rem;

  @media only screen and (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const LinkWrapper = styled.div`
  a {
    display: flex;
    flex-flow: column;
    text-decoration: none;
  }

  #arrow {
    color: #ccd8ff;
    font-size: 24px;

    margin-left: 0.5rem;

    min-height: 24px;
    min-width: 24px;
  }
`;

export const Title = styled.div`
  color: white;

  display: flex;
  align-items: center;

  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;

  svg {
    margin-left: 1rem;
  }

  @media only screen and (min-width: 1200px) {
    font-size: 1.5rem;
  }
`;

export const Paragraph = styled.div`
  color: #ccd8ff;
  font-family: ${({ theme }) => theme.fontBody};

  font-size: 1rem;
  line-height: 1.25rem;
  letter-spacing: 0.5px;

  margin-bottom: 1.25rem;

  @media only screen and (min-width: 1024px) {
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
`;
